export default {
  htmlTit: 'i-Search - Console',
  authorizationTip: 'Dear, login authorization time has expired or you have logged out, please login again',
  agreement: 'Hello, please read and agree to the following agreement:',
  agree: 'Agree',
  disagree: 'Disagree',
  noResponseData: 'Please contact the administrator or submit the work order; Please refresh the page later',
  goToOAuth: 'Going for login authorization...',
  authorize: 'Licensing...',
  logoutTip: 'Do you really want to log out?',
  developing: 'Under development, stay tuned...',
  applyTips: 'You are not a developer yet. Do you need to apply?',
  devClientAccess: 'Administrators cannot access developers',
  noData: 'NoData',
  read: 'I have read and agreed',
  agreen: 'i-search Application Market User Agreement',
  isRead: 'Please read and agree to the agreement first.',
  // 任务管理
  task: {
    taskManagement: 'Task Management',
    procName: 'Process Name',
    taskStatus: 'Task Status',
    robotRange: 'Robot',
    taskDetail: 'Task Detail',
    publish: 'publish',
    version: 'version',
    status: {
      pending: 'Pending',
      pendout: 'Pendout',
      running: 'Running',
      success: 'Success',
      timeout: 'Timeout',
      failing: 'Failing',
      failed: 'Failed',
      stopping: 'Stopping',
      stopped: 'Stopped'
    },
    start: 'Start',
    end: 'End',
    stopping: 'Ready to stop',
    readyToReDo: "It's ready to be redone",
    stopCheckTipMsg: 'Check if any of the selected tasks are executing',
    stopTipMsg: 'Confirm stop mission?',
    delCheckTipMsg: 'Check if any of the selected tasks are executing or ready to stop',
    delTipMsg: 'Are you sure to delete the task?',
    logDownloadMsg: 'No downloadable logs for this task'
  },
  // 变量管理
  variate: {
    variateManagement: 'Variates Management',
    variableName: 'Variable Name',
    variableValue: 'Value of variable',
    applicableRobot: 'Applicable Robot',
    clentModified: 'Clent Modified',
    mTitleAdd: 'Add',
    mTitleMod: 'Modify',
    variableInfo: 'Variable Info',
    variableJurisdiction: 'Variable Jurisdiction',
    delTipMsg: 'Are you sure to delete the variable?'
  },
  // 任务数据
  taskData: {
    taskDataM: 'Task Data',
    spaceName: 'Space Name',
    maxFailedAttempts: 'Max Failed Attempts',
    spaceDescription: 'Description',
    Last24Hours: 'Last 24 Hours',
    count: 'Total',
    success: 'Success',
    fail: 'Fail',
    other: 'Other',
    add: 'Add',
    modify: 'Modify',
    info: 'Info',
    jurisdiction: 'Jurisdiction',
    delTipMsg: 'Are you sure to delete the task data?',
    clearTipMsg: 'Are records cleared?',
    status: {
      pending: 'Pending',
      waittimeout: 'Wait Time Out',
      running: 'Running',
      success: 'Success',
      failed: 'failed',
      deleted: 'Deleted',
      retry: 'Retry'
    },
    // 查看数据
    view: {
      dataView: 'The data view',
      content: 'Content',
      customField: 'Custom Field',
      customFieldMsg: 'No data can be manipulated',
      fieldName: 'Field Name',
      choose: 'Choose',
      reference: 'Reference Value',
      displayName: 'Display Name',
      delTipMsg: 'Are you sure to delete the data?',
      restartTipMsg: 'Confirm redo?',
      setDisplayNameTip: 'Note: display names cannot be defined when unchecked'
    },
    // 访问记录
    logs: {
      back: 'Return',
      isBack: 'Confirm return?'
    }
  },
  // 机器人与设计器
  robotDes: {
    robotList: 'Robot List',
    agentnumbers: 'Agent Total Numbers',
    free: 'Free',
    running: 'Busy',
    offline: 'Offline',
    unbound: 'Unbound',
    abilityValue: 'Ability value',
    recharge: 'Recharge',
    rechargeInfo: ['Online capacity remaining points', 'Recharge method', 'Recharge amount', 'Points to be recharged', 'Instant recharge'],
    rechargeType: ['Alipay', 'WeChat', '{num} yuan'],
    rechargeTips: ['Please select the recharge method', 'Please select a recharge amount', 'Please read and agree to the agreement first.'],
    allStatus: 'Total status',
    buyRobot: 'Buying Robots',
    allowInfo: 'License Information',
    bindUser: 'Currently bound users',
    runStatus: 'Running State',
    newInfo: 'Recent information',
    login: 'Login',
    langLimt: 'Limit length to 0-128 characters',
    nameRequire: 'Name must be filled in',
    editName: 'Edit instance name',
    over: 'Be overdue',
    options: 'execution',
    isFee: 'Do you confirm a 30-day free extension?',
    isDel: 'Are you sure to delete the robot?',
    errAndOk: ['Executing', 'Successful Execution', 'Failing', 'Failed', 'Preparing to Stop', 'Stopped'],
    reFee: 'Please first choose robots or designers that need renewals.',
    apply: 'Extension',
    tabForm: ['Mailbox', 'Company', 'Mobile Number', 'Reason', 'Sale', 'Name'],
    isError: 'Please enter the correct {type}',
    isRequire: '{type} must be filled.',
    copyTip: 'Click copy',
    copyOK: 'Copy success',
    copyError: 'Copy failed, Please copy manually.'
  },
  // 流程管理
  process: {
    proManage: 'Process management',
    disable: 'Disable',
    enable: 'Enable',
    upload: 'Upload',
    file: 'File',
    ipkg: 'Please upload the ipkg file!',
    proName: 'Process name',
    runStatus: 'Running State',
    robotRange: 'Robot Range',
    schedule: 'Dispatch',
    taskTime: 'Next scheduling time',
    allRobot: 'All robots',
    total: 'Total',
    schDetail: 'schedule, click Edit to view details',
    robotDetail: 'robot, click Edit to view details',
    saveOrSet: 'Save and configure',
    delTip: 'Are you sure to delete the process?',
    isEnable: 'Is the process enabled?',
    isDisable: 'Is the process disabled?'
  },
  // 流程配置
  proConfig: {
    config: 'Process configuration',
    process: 'Process',
    robot: 'Robot',
    version: 'Version',
    name: 'name',
    seq: 'sort',
    timeMin: 'Manual execution time',
    timeOut: 'Timeout(s)',
    runModal: 'Operation mode',
    modal: 'Pattern',
    exprss: 'Expression',
    status: 'State',
    time: 'Time',
    schTime: 'Scheduling time',
    timing: 'Timing',
    minute: 'Per minute',
    hour: 'Hours',
    day: 'Daily',
    week: 'Weekly',
    month: 'Monthly',
    define: 'Custom',
    startTime: 'Start time',
    interval: 'every other',
    minu: 'Minute',
    once: 'once',
    eTime: 'Execution time',
    score: 'minutes',
    tHour: 'hour',
    tWeek: 'week',
    selMon: 'Selection Month',
    selDay: 'Choice day',
    expr: 'Expression',
    senSet: 'Advanced setting',
    efficeTime: 'Effective date',
    waitTime: 'waiting overtime',
    weekRun: 'workday operation',
    failTimes: 'number of failed retries',
    waitTimeArr: ['30 seconds', '1 minute', '30 minutes', '1 hour', '8 hours', '1 day'],
    lastMonth: 'Last day of the month',
    disDel: 'Active versions cannot be deleted',
    selRobot: 'Select a Robot',
    weekArr: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    modeArr: ['Timing', 'Start', 'Permanent'],
    isBack: 'If returned, the content you modified will be lost. Are you sure to return?',
    errDate: 'Please select a effective date',
    errStart: 'Please choose the start time',
    errMin: 'Every XXX must be filled in, and it is a number',
    errTime: 'Execution time must be filled in',
    errWeek: 'Please choose a week',
    errMonth: 'Please choose the month',
    errDay: 'Please choose the day',
    errExpre: 'Expressions must be filled in',
    errName: 'Process name must be filled in',
    tempStart: 'Successful start-up of temporary tasks',
    monArr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    global: 'Mode',
    globalType: ['Daily Execution', 'Workday Execution', 'Non-Workday Execution'],
    set: 'Extra time',
    tipScript: ['Execution', 'No Execution']
  },
  // 访问记录
  varRecord: {
    viewRecord: 'Access Records',
    colTable: ['Action', 'Robot', 'Process', 'Task Number', 'Time'],
    isClear: 'Are clearance records confirmed?'
  },
  // 我的账户
  myAccount: {
    menu: ['Basic Settings', 'Security Settings', 'Account Binding', 'Recommended gift'],
    submit: 'Submit',
    formItem: ['Industry', 'Nickname', 'Company Name', 'Country/Region', 'Address', 'Contact Phone'],
    upHead: 'Upload the Avatar',
    tipPhone: 'Please enter the correct cell phone number',
    tipUpload: 'Uploaded pictures should not exceed 10M',
    curAccount: 'Security of your current account',
    securityLevel: 'Security level',
    levelList: ['Low', 'Middle', 'High'],
    continue: 'Keep trying',
    securType: ['Login Password', 'Mobile Binding', 'Mailbox Binding'],
    tipPwd: 'High security passwords can make accounts safer. It is recommended that you change your password regularly and set a password that contains at least two letters, symbols or numbers and is longer than 7 bits.',
    securState: ['Set', 'Modified', 'Binded', 'Unbound', 'Unbound', 'Binded'],
    bindPhone: `You've bound your cell phone`,
    phone: 'Your mobile phone is a secure mobile phone, you can retrieve the password',
    bindEmail: 'You have bound your mailbox',
    accountList: ['Wechat Account', 'Ding Account'],
    isBind: 'Do you confirm unbinding?',
    NickName: 'A nickname cannot contain an art flag.',
    gift: ['Recommend friends to win massive Y coins', 'Every time you recommend a friend to sign up for the Artisan Flag Eco ID, you will receive a reward of ', 'Y coins (can be used to ', 'redeem gifts and products around the ', 'You have now recommended', 'registrations to complete the Art Flag ID!', 'Sweep to complete the recommended registration', 'Copy QR code', 'Copy registration link', 'Once malicious behavior is discovered, legal liability will be pursued. The final interpretation right belongs to the art flag'],
    yMall: 'Y coin mall'
  },
  // 业务日志
  bLog: {
    title: 'Business log',
    delTip: 'Are you sure you want to delete the business log?',
    delViewCon: 'Select the view you want to delete first',
    delViewTip: 'Are you sure to delete the selected view?',
    conOne: 'Table display must retain a field',
    errView: 'Please enter the view name',
    requireOne: 'You must add a custom field',
    isChoose: 'You have not added the view, please add it first.',
    defView: 'Default',
    viewM: 'View Management',
    viewN: 'View Name',
    viewT: 'Time',
    viewText: 'View',
    errTip: 'Select the data you want to delete first'
  },
  // 投资报表
  roi: {
    title: 'Return On Investment',
    monArr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    panelTitle: ['Robot Number', 'Robot Running Time (Minutes)', 'Task Log'],
    invest: 'RPA-Synthesis-Investment Return Analysis',
    lineArr: ['SaveTime%', 'Manual time', 'Robot time'],
    logTab: ['Time', 'Robot', 'Process', 'Execution Time(min)', 'Relative Labor Time(min)', 'Status', 'Exception', 'Description', 'Executive Outcome', 'Wait Time(min)']
  },
  // 报表中心
  report: {
    title: 'RPA consolidated report - {title}',
    process: {
      count: 'RPA - KPI - Recently Executed Processes',
      task: 'RPA - Distribution - Process Tasks',
      error: 'RPA - Distribution - Process Errors',
      taskTrend: 'RPA - Trend Stack - Process Tasks',
      timeTrend: 'RPA - Trend Stack - Process Time(min)',
      log: 'RPA Task Logs'
    },
    robot: {
      count: 'RPA - KPI - Number of robots',
      runTime: 'RPA - KPI - Robot running time (min)',
      task: 'RPA - Distribution - Robot Tasks',
      error: 'RPA - Distribution -  Robot Errors',
      taskTrend: 'RPA - Trend Stack - Robot Tasks',
      timeTrend: 'RPA - Trend Stack - Robot WT (min)',
      log: 'RPA Task Logs'
    },
    task: {
      count: 'Number of tasks',
      duration: 'Average task duration (min)',
      fails: 'Failed Tasks',
      error: 'Task error cause',
      taskTrend: 'Task trend',
      timeTrend: 'Robot running time (min)',
      log: 'Task Logs',
      errLog: 'Error Logs',
      failed: 'Failure'
    }
  },
  // 新手包
  novice: {
    renew: 'Your designer/robot is about to expire, buy ',
    ext: 'extension!',
    tip: 'Tip: An ID can only be purchased once, see activity rules >',
    closeTip: 'Do not remind again',
    buy: 'Buy now',
    titleH31: 'Novice spree',
    erTip: 'You have already purchased, one person can only buy once, not repeat purchase',
    cancenTip: 'If you have an order to be paid, please cancel before you can buy again.',
    pay: 'WeChat | Alipay | PayPal',
    open: 'Open Mobile WeChat | Open Mobile Alipay | Open the PayPal website',
    sace: 'Sweep the payment | Click the link to payments',
    popUps: ['Make sure the package you purchased', 'As low as ', ' yuan', 'Original price ', 'Click to select payment method']
  },
  // 我的卡包
  card: {
    title: 'My card package',
    status: ['all', 'unused', 'used', 'expired', 'invalid'],
    card: 'Exchange cards',
    tdThed: ['Valid', 'Product', 'Card', 'BuyTime', 'OrderNo'],
    time: 'After {s}s,',
    again: 'Re-extract password',
    msg: 'The password has been re-extracted to {pwd}, please check',
    tip: 'Cannot be re-acquired in a short time, please try again later'
  },
  // other
  'app.exception.description.403': 'Sorry, you don\'t have access to this page',
  'app.exception.description.404': 'Sorry, the page you visited does not exist',
  'app.exception.description.500': 'Sorry, the server is reporting an error',
  'component.globalHeader.footer.links': 'China\'s first RPA vendor',
  'component.globalHeader.footer.copyright': 'Shanghai i-Search Software Co., Ltd.,',
  'app.switchlang.success': 'Switch Lang Success!'
}
